import React from "react";
import { Card, ListGroup } from "react-bootstrap";
import { IOrder } from "common/types";

interface ExpandedStudentPaidOrderProps {
  data: IOrder;
}

const ExpandedStudentPaidOrder: React.FC<ExpandedStudentPaidOrderProps> = ({
  data,
}) => {
  return (
    <Card style={{ width: "100%" }}>
      <Card.Body>
        <Card.Title>Dodatne informacije o narudžbi</Card.Title>
        <ListGroup variant="flush">
          <ListGroup.Item>
            <strong>ID Narudžbe:</strong> {data.id}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Datum kreiranja:</strong>{" "}
            {new Date(data.created_at).toLocaleString("hr-HR")}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Datum plaćanja:</strong>{" "}
            {data.date_paid
              ? new Date(data.date_paid).toLocaleString("hr-HR")
              : "Nije dostupno"}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Grupa priprema:</strong> {data.course.title}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Iznos:</strong> {data.amount} EUR
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Ime:</strong> {data.customer.first_name}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Prezime:</strong> {data.customer.last_name}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Škola:</strong> {data.customer.profile.school}
          </ListGroup.Item>
        </ListGroup>
      </Card.Body>
    </Card>
  );
};

export default ExpandedStudentPaidOrder;
